/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: layerClientReducers.js
 *
 * Created by robertcaslin.
 */


import {
    LAYER_CLIENT,
    CLIENT_READY,
    OWNER_SET
} from '../actions/messenger';

const initialState = {
    client:{},
    ready: false,
    clientReady: false,
    owner: {}
};

export default function layerClientReducer(state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case CLIENT_READY:
            return {
                ...state,
                ready: true,
                clientReady: true
            };
        case OWNER_SET:
            return {
                ...state,
                owner: payload.owner,
            };
        case LAYER_CLIENT:
            return {
                ...state,
                client: payload.client,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/layerClientReducers.js